
<template lang="pug">
.flex.items-center
  QSelectMod.select-period(
    v-bind="$attrs"
    :value="value"
    :options="options"
    popup-max-height="36rem"
    v-on="listeners"
  )

  template(v-if="buttons")
    q-btn(
      flat round dense
      :disable="prevValue == null"
      @click="change(prevValue)"
    ) 前

    q-btn(
      flat round dense
      :disable="nextValue == null"
      @click="change(nextValue)"
    ) 次

</template>

<script>
import {isValid} from 'date-fns/esm'
import {get} from 'lodash-es'

import {dateToObject, dateFilter} from 'helpers/date'
import {mapGetters} from 'vuex'

import QSelectMod from 'components/QSelectMod'

export default {
  components: {QSelectMod},

  props: {
    value: {required: true},
    buttons: {type: Boolean, default: false},
  },

  computed: {
    ...mapGetters(['latestPeriod', 'periods', 'getNearestPeriod']),

    listeners() {
      return {
        ...this.$listeners,
        input: value => {this.change(value)},
        change: () => {},
      }
    },

    options() {
      return this.periods.reduceRight((acc, period) => ([...acc, {
        value: period.begin,
        label: dateFilter(period.begin, 'yyyy年M月d日〜'),
      }]), [])
    },

    currentIndex() {
      return this.options.findIndex(({value}) => value <= this.value)
    },

    prevValue() {
      return get(this.options, [this.currentIndex + 1, 'value'])
    },

    nextValue() {
      return get(this.options, [this.currentIndex - 1, 'value'])
    },

    validValue() {
      let date = dateToObject(this.value)
      if(!isValid(date)) {
        date = dateToObject(this.latestPeriod.begin)
      }
      return this.getNearestPeriod(date).begin
    },
  },

  watch: {
    validValue: {
      immediate: true,
      handler(value) {
        if(value !== this.value) {
          this.change(value)
        }
      },
    },
  },

  methods: {
    change(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="sass">
.select-period
  width: 11rem
</style>
